export default "__VITE_ASSET__Dpx9kTFX__"